export default function checkPermission(
    profile,
    permitted = ['master', 'super_admin', 'admin']
) {
    const permission =
        profile && profile.permission ? profile.permission : false;

    return permitted.includes(permission);
}
